pageId = 'page-member-settings-redpack'
page = '#' + pageId

$ ->
  $(document).on 'click', "#{page} .link-bind-wechat, #{page} .link-withdraw", showWechatBindDialog
  .on 'ajax:success', "#{ page } .link-unbind-wechat", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true
  .on 'ajax:success', "#{ page } .link-draw", (e, result) ->
    if result.success
      tower.stack.load location.href,
        replace: true
    else
      $("#{page} .link-draw[data-guid='#{result.guid}'] > .draw-msg").html('出了点问题，请重新')

  $('body').on 'click', "#{ page } .link-draw", (e) ->
    hour = moment().hours()
    if hour >= 0 and hour < 8
      remaining = if(8 - hour) > 1 then (8 - hour) + '小时' else '不到一小时'
      simple.dialog.message
        content: "凌晨 0 点到早上 8 点 Tower 钱包正在盘点，请在其他时间段申请提现。<br/>您还需要等待大约 #{ remaining }。",
        modal: true
      return false
    return true


showWechatBindDialog = (e)->
  content = $("#tpl-redpacks-bind-wechat").html()
  dialog = simple.dialog
    content: content
    cls: 'redpacks-dialog'
    width: 400
    modal: true
    buttons: null

  $.ajax
    url: '/wechat/qrcode/?type=9'
    type: 'get'
    dataType: 'json'
    success: (result) ->
      return  unless result.success

      dialog.el.find('img.qrcode')
        .attr 'src', result.qrcode_url

      channel = tower.tempPusher(result.channel)
      channel.bind 'pusher:subscription_succeeded', ->
        $('.qrcode-wrap').removeClass('loading')
          .find('.indicator').remove()

      .bind 'WECHAT_ONLY_BIND', (result) ->
        $qrSheet = dialog.el.find('.qrcode-sheet')
        $suSheet = dialog.el.find('.success-sheet')
        if result.success
          setTimeout ->
            tower.stack.load location.href,
              replace: true
          , 2000
        else
          $qrSheet.find('.error').remove()
          $("<p class='error'>#{ result.message }</p>").appendTo $qrSheet
          dialog.refresh()

        tower.tempPusherSocket.disconnect()  if !!tower.tempPusherSocket
        tower.tempPusherSocket = null
